import { styled } from '../../system';
export const StyledButtonIcon = styled('span', {
    flexCenter: true,
    display: 'inline-flex',
    lineHeight: '$none',
    '> svg': {
        display: 'inline-block',
        lineHeight: 0
    },
    variants: {
        position: {
            left: {
                mr: '$2'
            },
            right: {
                ml: '$2'
            }
        }
    }
});
